import { Box, IconButton, Button } from "@mui/material";
import React, { Fragment, useMemo, useState, useEffect } from "react";
import { Card, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteAppConfig,
  editConfig,
  getAppConfig,
  jobAction,
  setAppConfig,
  updateAppConfig,
} from "../../../Utils/actions";
// import { DataType, SortingMode } from 'ka-table/enums';
import { useTranslation } from "react-i18next";
// import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
// import { kaReducer } from 'ka-table';
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import {
  Edit as EditIcon,
  Delete as DeleteIcon,
  ExitToApp as ExitIcon,
} from "@mui/icons-material";
import { useLocation } from "react-router-dom";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import LastPageIcon from "@mui/icons-material/LastPage";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import FormControl from "@mui/material/FormControl";
import { Select, MenuItem } from "@mui/material";

const AppConfigPage = ({
  setFinish,
  pageSizeAppProp,
  pageIndexAppProp,
  setPageIndexAppProp,
  setPageSizeAppProp,
}) => {
  const [form, setForm] = useState({ propertykey: "", propertyvalue: "" });
  const [error, setError] = useState({ propertykey: "", propertyvalue: "" });
  const dispatch = useDispatch();
  const { appConfigData, appConfigDataTotalRecord } = useSelector(
    (state) => state.data
  );

sessionStorage.setItem('appPropPageSize',pageSizeAppProp);
  const handleChange = (e) => {
    setError({ ...error, [e.target.name]: "" });
    setForm({ ...form, [e.target.name]: e.target.value.toString() });
  };

  const location = useLocation();

  const { t } = useTranslation();



  const appConfigColumns = useMemo(
    () => [
      {
        accessorKey: "propertykey",
        header: "Property Key",
        enableEditing: false,
      },
      {
        accessorKey: "propertyvalue",
        header: "Property Value",
        enableEditing: true,
      },
    ],
    [t]
  );

  const onHandleSave = ({ row, table, pageSizeAppProp, pageIndexAppProp }) => {
    dispatch(updateAppConfig(row, pageSizeAppProp, pageIndexAppProp));
    table.setEditingRow(null);
  };

  const handlePageChange = (newPageIndex) => {
    setPageIndexAppProp(newPageIndex);
  };
  const handleStartChange = () => {
    setPageIndexAppProp(0);
  };

  const handleEndChange = () => {
    const totalPages = Math.ceil(appConfigDataTotalRecord / pageSizeAppProp);
    setPageIndexAppProp(totalPages - 1);
  };

  const handlePageSizeChange = (newPageSize) => {
    setPageSizeAppProp(newPageSize);
    setPageIndexAppProp(0);
  };

  return (
    <Fragment>
      <Card className=" mx-auto app-cnfg user-roles overflow-hide shadow-none m-0 p-0 border-0">
        <Card.Body
          className="cardBody"
          style={{ padding: "0", margin: "0", overflow: "auto" }}
        >
          <MaterialReactTable
            muiTableHeadCellProps={{
              sx: {
                backgroundColor: "#286685",
                color: "#fff",
              },
            }}
            muiTableContainerProps={{
              sx: {
                maxHeight: "55vh !important",
                overflowY: "auto",
                overflowX: "auto",
              },
            }}
            muiTableBodyRowProps={({ row, index }) => ({
              sx: {
                backgroundColor: row.getIsSelected()
                  ? "bold"
                  : index % 2 === 0
                  ? "#cfd5e959"
                  : "white",
              },
            })}
            muiTableBodyProps={{
              sx: {
                "& tr:nth-of-type(odd)": {
                  backgroundColor: "#cfd5e959",
                },
                "& td": {
                  padding: "0.5rem",
                  borderBottom: "1px solid #ccc",
                },
              },
            }}
            muiPaginationProps={({ table }) => ({
              // count: Math.ceil(appConfigDataTotalRecord / appConfigPagination.pageSize),
              // page: appConfigPagination.pageIndex + 1,
              // rowsPerPageOptions: [5, 10, 15, 20, 50], // Define your desired rows per page options
              // rowsPerPage: appConfigPagination.pageSize, // Set the current rows per page value
              showRowsPerPage: true,
              // onChangePage: (event, page) => {
              //   table.setPage(page);
              //   setAppConfigPagination({pageIndex: table.nextPage, pageSize: table.getPageCount })
              // },
              // onChangeRowsPerPage: (event) => {
              //   table.setPageSize(parseInt(event.target.value.pageSize, 10));
              //   table.setPage(0); // Reset to the first page when changing rows per page
              //   setAppConfigPagination({pageIndex: table.nextPage, pageSize: table.getPageCount })
              // }
            })}
            muiTablePaperProps={{ sx: { boxShadow: "none" } }}
            columns={appConfigColumns}
            data={appConfigData}
            enableStickyHeader={true}
            positionActionsColumn="last"
            enableRowActions
            editDisplayMode={"row"}
            enableTableFooter={true}
            enableEditing={true}
            enableDensityToggle={false}
            enableFullScreenToggle={false}
            // enableFilters={false}
            enableHiding={false}
            // createDisplayMode: 'modal'
            onEditingRowSave={onHandleSave}
            // manualPagination={true}
            // paginationDisplayMode="pages"
            rowCount={appConfigDataTotalRecord}
            // onPaginationChange={(newPagination) => {
            //   setAppConfigPagination(newPagination);
            // }}
            // state={appConfigPagination}
            enablePagination={false}
            renderBottomToolbarCustomActions={({ table }) => (
              <>
                <div style={{ marginLeft: "auto" }}>
                  <span>Rows per Page </span>&nbsp;
                  <FormControl variant="standard" size="small">
                    <Select
                      value={pageSizeAppProp}
                      onChange={(e) =>
                        handlePageSizeChange(Number(e.target.value))
                      }
                    >
                      <MenuItem value={5}>5</MenuItem>
                      <MenuItem value={10}>10</MenuItem>
                      <MenuItem value={20}>20</MenuItem>
                      <MenuItem value={50}>50</MenuItem>
                      <MenuItem value={100}>100</MenuItem>
                    </Select>
                  </FormControl>
                  &nbsp;
                  <span>
                    {pageIndexAppProp * pageSizeAppProp + 1}-
                    {Math.min(
                      pageIndexAppProp * pageSizeAppProp + pageSizeAppProp,
                      appConfigDataTotalRecord
                    )}{" "}
                    of &nbsp;
                    {appConfigDataTotalRecord}&nbsp;
                  </span>
                  <FirstPageIcon
                    onClick={() => {
                      if (pageIndexAppProp !== 0) {
                        handleStartChange();
                      }
                    }}
                    style={{
                      cursor:
                        pageIndexAppProp === 0 ? "not-allowed" : "pointer",
                      color:
                        pageIndexAppProp === 0
                          ? "rgba(0, 0, 0, 0.26)"
                          : "inherit",
                    }}
                  />
                  <NavigateBeforeIcon
                    onClick={() => {
                      if (pageIndexAppProp !== 0) {
                        handlePageChange(pageIndexAppProp - 1);
                      }
                    }}
                    style={{
                      cursor:
                        pageIndexAppProp === 0 ? "not-allowed" : "pointer",
                      color:
                        pageIndexAppProp === 0
                          ? "rgba(0, 0, 0, 0.26)"
                          : "inherit",
                    }}
                  />
                  <NavigateNextIcon
                    onClick={() => {
                      if (
                        (pageIndexAppProp + 1) * pageSizeAppProp <
                        appConfigDataTotalRecord
                      ) {
                        handlePageChange(pageIndexAppProp + 1);
                      }
                    }}
                    style={{
                      cursor:
                        (pageIndexAppProp + 1) * pageSizeAppProp >=
                        appConfigDataTotalRecord
                          ? "not-allowed"
                          : "pointer",
                      color:
                        (pageIndexAppProp + 1) * pageSizeAppProp >=
                        appConfigDataTotalRecord
                          ? "rgba(0, 0, 0, 0.26)"
                          : "inherit",
                    }}
                  />
                  <LastPageIcon
                    onClick={() => {
                      if (
                        (pageIndexAppProp + 1) * pageSizeAppProp <
                        appConfigDataTotalRecord
                      ) {
                        handleEndChange();
                      }
                    }}
                    style={{
                      cursor:
                        (pageIndexAppProp + 1) * pageSizeAppProp >=
                        appConfigDataTotalRecord
                          ? "not-allowed"
                          : "pointer",
                      color:
                        (pageIndexAppProp + 1) * pageSizeAppProp >=
                        appConfigDataTotalRecord
                          ? "rgba(0, 0, 0, 0.26)"
                          : "inherit",
                    }}
                  />
                </div>
              </>
            )}
            renderTopToolbarCustomActions={({ table }) => (
              <div className="d-flex float-end">
                {location.pathname === "/validForm" ? (
                  <Button
                    onClick={setFinish}
                    startIcon={<ExitIcon />}
                    style={{
                      backgroundColor: "#286685",
                      color: "#fff",
                      width: "100px",
                    }}
                  >
                    Exit
                  </Button>
                ) : null}
              </div>
            )}
            renderRowActions={({ row, table }) => (
              <Box sx={{ display: "flex", flexWrap: "nowrap", gap: "8px" }}>
                <IconButton
                  sx={{ color: "#286685" }}
                  onClick={() => {
                    table.setEditingRow(row);
                  }}
                >
                  <EditIcon />
                </IconButton>
              </Box>
            )}
          />
        </Card.Body>
      </Card>
    </Fragment>
  );
};

export default AppConfigPage;
